import { __values } from "tslib";
var EntityConfig = (function () {
    function EntityConfig(proto) {
        this.proto = proto;
        this.wasReflectLoaded = "getMetadata" in Reflect;
        this.fields = new Map();
    }
    EntityConfig.prototype.getFields = function () {
        return Array.from(this.fields.values());
    };
    EntityConfig.prototype.eachField = function (visit) {
        var e_1, _a;
        try {
            for (var _b = __values(this.fields.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var f = _c.value;
                visit(f);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    EntityConfig.prototype.addField = function (field) {
        field.initialize(this);
        this.fields.set(field.name, field);
    };
    EntityConfig.prototype.clone = function (proto) {
        var newConfig = new EntityConfig(proto);
        this.fields.forEach(function (f) { return newConfig.addField(f.clone()); });
        newConfig.fields.forEach(function (f) { return f.initialize(newConfig); });
        return newConfig;
    };
    EntityConfig.forInstance = function (entity) {
        return this.forPrototype(Object.getPrototypeOf(entity));
    };
    EntityConfig.forConstructor = function (constructor) {
        return this.forPrototype(constructor.prototype);
    };
    EntityConfig.forPrototype = function (proto) {
        var _a;
        var p = proto;
        var config = (_a = p[ENTITY_CONFIGURATION_KEY]) !== null && _a !== void 0 ? _a : new EntityConfig(p);
        if (config.proto !== p) {
            config = config.clone(p);
        }
        p[ENTITY_CONFIGURATION_KEY] = config;
        return config;
    };
    return EntityConfig;
}());
export { EntityConfig };
export var ENTITY_CONFIGURATION_KEY = Symbol("ENTITY_CONFIGURATION");
